<template lang="pug">
.wrapperr(v-if='ativarJanela')
    .bloco
        .bloco-head
            h2 {{ $t('mensagens.monitoramentoSocioambiental.novoMonitoramento.processaMonitoramento.titulo') }}

            .icons-box
                i.mdi.bloco-icon.mdi-chevron-right(
                    v-if='steps !== "download"',
                    :class='[minimizarBloco ? "mdi-window-minimize" : "mdi-window-maximize"]',
                    @click='minimizarBloco = !minimizarBloco'
                )
                i.mdi.bloco-icon.mdi-close-circle-outline(
                    @click='cancelarMonitoramento'
                )

        transition(name='slide')
            .bloco-body(v-if='minimizarBloco')
                el-table(:data='tableData', style='width: 100%')
                    el-table-column(
                        prop='name',
                        label='Território',
                        width='150'
                    )
                    el-table-column(
                        prop='address',
                        label='Localidade',
                        width='150'
                    )

                .loading(v-if='steps == "carregamento"')
                    i.el-icon-loading
                    p {{ $t('mensagens.diagnosticoSocioambiental.exportacao.documentoCarregando') }}
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import VueElementLoading from 'vue-element-loading';
import areasMonitoradasService from '@/services/AreasMonitoradasService';
import { cancelAllRequests } from '../../utils/http.js';

export default {
    name: 'MonitorarProcessamento',
    data() {
        return {
            minimizarBloco: true,
            ativarJanela: false,
            steps: 'listagem',
            link: null,
            tableData: []
        };
    },
    computed: {
        ...mapGetters([
            'processandoMonitoramento',
            'listaMonitoramentos',
            'usuarioLogado'
        ])
    },
    components: {
        VueElementLoading
    },

    watch: {
        processandoMonitoramento: {
            handler: function () {
                this.ativarJanela = this.processandoMonitoramento;
            },
            immediate: true
        },

        listaMonitoramentos: {
            handler: function () {
                if (this.listaMonitoramentos.length > 0) {
                    this.listaMonitoramentos.map(item => {
                        this.tableData.push({
                            item: item,
                            name: item.nome,
                            address: item.localidade
                        });
                    });
                    this.handleNotificar();
                }
            },
            immediate: true
        }
    },

    methods: {
        ...mapActions(['setProcessandoMonitoramento']),

        async handleCancelar() {
            await this.$messageBox
                .confirm(
                    this.$t(
                        'mensagens.monitoramentoSocioambiental.monitorarProcessamento.cancelarMensagem'
                    ),
                    this.$t(
                        'mensagens.monitoramentoSocioambiental.monitorarProcessamento.aviso'
                    ),
                    {
                        confirmButtonText: this.$t('mensagens.comuns.sim'),
                        cancelButtonText: this.$t('mensagens.comuns.cancelar'),
                        type: 'warning'
                    }
                )
                .then(async () => {
                    this.setProcessandoMonitoramento(false);
                    this.clear();
                });
        },

        clear() {
            this.ativarJanela = false;
        },

        async handleNotificar() {
            await this.$messageBox.alert(
                this.$t(
                    'mensagens.monitoramentoSocioambiental.novoMonitoramento.processaMonitoramento.alertaMensagem'
                ),
                this.$t(
                    'mensagens.monitoramentoSocioambiental.novoMonitoramento.processaMonitoramento.aviso'
                ),
                {
                    confirmButtonText: this.$t('mensagens.comuns.ok'),
                    type: 'sucess'
                }
            );
        },
        async cancelarMonitoramento() {
            const result = await this.$messageBox.confirm(
                this.$t(
                    'mensagens.monitoramentoSocioambiental.novoMonitoramento.processaMonitoramento.cancelarEnvio'
                ),
                'Aviso',
                {
                    confirmButtonText: 'Sim',
                    cancelButtonText: 'Fechar',
                    type: 'warning'
                }
            );
            if (result) {
                this.confirmaCancelamento();
            }
        },
        async confirmaCancelamento() {
            cancelAllRequests();

            const idsAreaMonitorada = [];
            this.tableData.forEach(el => idsAreaMonitorada.push(el.item.id));

            await areasMonitoradasService.desativarMonitoramentos({
                idsAreaMonitorada
            });

            this.tableData = [];
            this.$router.push({
                name: 'MonitoramentoSocioambiental'
            });
            this.ativarJanela = false;
        }
    }
};
</script>
<style lang="scss">
.minimizar-enter-active,
.minimizar-leave-active {
    transition: opacity 0.5s ease;
}

.minimizar-enter-from,
.minimizar-leave-to {
    opacity: 0;
}
.wrapperr {
    position: fixed;
    bottom: 0;
    right: 0;
    z-index: 20000;
}

.bloco {
    position: absolute;
    right: 20px;
    bottom: 0px;
    background: var(--white);
    width: 300px;
    border-radius: 5px 5px 0px 0px;
}
.bloco-head {
    width: inherit;
    height: 45px;
    background: var(--primary);
    padding: 8px;
    border-radius: 5px 5px 0px 0px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
}
.bloco-head h2 {
    color: var(--white);
    display: inline-block;
    font-size: 14px;
}
.bloco-head .bloco-icon {
    color: var(--white);
    font-size: 24px;
    cursor: pointer;
}
.bloco-body {
    height: 216px;
    width: inherit;
    overflow: auto;
    margin-bottom: 53px;
}
.bloco-lista ul {
    list-style: none;
    margin: 0;
    padding: 9px;
}
.bloco-lista ul li {
    display: flex;
    justify-content: space-between;
    margin: 0;
    padding: 0;
    align-items: center;
    line-height: 17px;
    margin-bottom: 12px;
}
.bloco-lista ul li .mdi {
    font-size: 17px;
    color: #545454;
    cursor: pointer;
}

.bloco-lista ul li .mdi:hover {
    color: red;
}

.bloco-lista ul li span {
    font-size: 12px;
}

.bloco-footer {
    position: fixed;
    bottom: 0;
    display: flex;
    justify-content: space-between;
    width: 300px;
    padding: 0px 4px 4px 4px;
}

.slide-enter-active {
    -moz-transition-duration: 0.2s;
    -webkit-transition-duration: 0.2s;
    -o-transition-duration: 0.2s;
    transition-duration: 0.2s;
    -moz-transition-timing-function: linear;
    -webkit-transition-timing-function: linear;
    -o-transition-timing-function: linear;
    transition-timing-function: linear;
}

.slide-leave-active {
    -moz-transition-duration: 0.2s;
    -webkit-transition-duration: 0.2s;
    -o-transition-duration: 0.2s;
    transition-duration: 0.2s;
}

.slide-enter-to,
.slide-leave {
    max-height: 100px;
    overflow: hidden;
}

.slide-enter,
.slide-leave-to {
    overflow: hidden;
    max-height: 0;
}

.loading {
    i {
        font-size: 35px;
        margin-bottom: 20px;
    }

    padding: 30px 20px;
    text-align: center;
}

.download {
    padding: 80px 20px 0px;
    text-align: center;
}

.el-message-box__btns {
    button {
        width: 100px !important;
    }

    .el-button--primary {
        background-color: var(--primary);
        border-color: var(--primary);
        color: var(--white);
    }

    .el-button--primary:hover,
    .el-button--primary:focus {
        background-color: var(--secondary);
        border-color: var(--secondary);
        color: var(--color-button-hover);
        outline: 0px auto var(--secondary);
    }
}
.icons-box {
    display: flex;
    flex-direction: row;
    i {
        margin: 0 5px;
    }
}
</style>
